'use client';
import dynamic from 'next/dynamic';
const ChatShare = dynamic(() => import('@whelk/components/src/Download'), { ssr: false });

export default ChatShare;
